import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <main id="main" className="contact">
      <div className="contact-hero">
        <div className="contact-glow" aria-hidden="true" />
        <div className="wrap">
          <h1>
            That page <span className="gradient-text">moved</span>.
          </h1>
          <p className="legal-lede">
            Nothing lives at this address. The pages people usually want are one
            click away.
          </p>
          <div className="mail-row">
            <Link className="btn" to="/">
              Back home
            </Link>
            <Link className="btn ghost" to="/privacy">
              Privacy policy
            </Link>
            <Link className="btn ghost" to="/delete-account">
              Delete account
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default NotFound;
